const NON_BILLABLE_ROLES = ['mes_operator', 'mes_admin', 'accounts_manager'];

const get_non_internal_non_mes_user_count = (all_users) => {
    let non_internal_users = all_users.filter(x => !x.internal).filter(x => !x.deprecated);
    let billable_users = non_internal_users.filter(x => {
        let r = Array.from(new Set(x.roles));
        r = r.filter(role => !NON_BILLABLE_ROLES.includes(role));
        return r.length > 0;
    });
    return billable_users.length;
}

export {get_non_internal_non_mes_user_count}
